import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './../Styles/History.css';
import AppHeader from './AppHeader';
import AcknowledgmentButton from './AcknowledgmentButton';
const apiUrl = process.env.REACT_APP_API_URL;

const History = () => {
    const [submittedGoals, setSubmittedGoals] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [employeeInfo, setEmployeeInfo] = useState({ full_name: '', job_title: '', employee_number: '' });

    const [acknowledgedStatus, setAcknowledgedStatus] = useState({});
    const [goals, setGoals] = useState([]);
    
    // Fetching employee information and submitted goals on component load
    useEffect(() => {
        const fetchEmployeeInfo = async () => {
            const employeeId = localStorage.getItem('employeeId'); // Getting employee ID from local storage
            if (!employeeId) {
                console.error('Employee ID not found in local storage.');
                return;
            }
            try {
                const response = await axios.get(`${apiUrl}/api/employee-info/${employeeId}`); // API call to fetch employee info
                setEmployeeInfo(response.data); // Setting employee info
            } catch (error) {
                console.error('Error fetching employee info:', error);
            }
        };

        const fetchSubmittedGoals = async () => {
            setIsLoading(true); // Setting loading state
            const employeeId = localStorage.getItem('employeeId'); // Getting employee ID from local storage
            if (!employeeId) {
                console.error('Employee ID not found in local storage.');
                setIsLoading(false);
                return;
            }
            try {
                const response = await axios.get(`${apiUrl}/api/submitted-goals/${employeeId}`); // API call to fetch submitted goals
                setSubmittedGoals(response.data); // Setting the submitted goals data
                  // Set acknowledgment statuses
                   // Now fetch the acknowledgment status from the employee_reviews table
                  const quartersResponse = await axios.get(`${apiUrl}/api/available-quarters/${employeeId}`);
                  const quarters = quartersResponse.data; // List of dynamic quarters
        
                 const acknowledgmentStatuses = {};
        
                 // Now fetch acknowledgment statuses per quarter
                 for (const quarter of quarters) {
                      const reviewsResponse = await axios.get(`${apiUrl}/api/employee-reviews/${employeeId}/${quarter}`);
                      const review = reviewsResponse.data[0]; // Assuming one review per quarter
                    
                     
            // Log the entire review object
            console.log(`Full review data for ${quarter}:`, review);
            
            if (review) {
                // MongoDB stores acknowledge as Boolean (true/false),
                // not as a MySQL tinyint (1/0), so compare directly.
                const isAcknowledged = review.acknowledge === true;
                
                console.log(`Acknowledged value for ${quarter}:`, review.acknowledge, `(boolean)`);
                
                if (isAcknowledged) {
                    acknowledgmentStatuses[quarter] = 1; // Mark as acknowledged
                } else {
                    acknowledgmentStatuses[quarter] = 0; // Default to not acknowledged
                }
            } else {
                acknowledgmentStatuses[quarter] = 0; // Default to 0 if no review found
                console.warn(`No review found for ${quarter}. Defaulting to acknowledgment status 0.`);
            }
        }
        
        setAcknowledgedStatus(acknowledgmentStatuses); // Set acknowledgment statuses in state
        console.log("Acknowledgment statuses: ", acknowledgmentStatuses); // Log for debugging
            } catch (error) {
                console.error('Error fetching submitted goals:', error);
            }
            setIsLoading(false); // Stopping the loading state
        };

        fetchEmployeeInfo();
        fetchSubmittedGoals();
    }, []);

    // Update acknowledgment status locally when acknowledgment is made
     const handleAcknowledged = (quarter) => {
        setAcknowledgedStatus((prevStatus) => ({
            ...prevStatus,
            [quarter]: true,
        }));
    };

    const updateAcknowledgedState = (goalId) => {
        setAcknowledgedStatus((prevStatus) => ({
            ...prevStatus,
            [goalId]: true, // Mark this quarter as acknowledged
        }));
    };
    

    // Function to group goals by quarter and render them as horizontal cards
    const renderQuarterCards = () => {
        const quarterGroups = submittedGoals.reduce((acc, goal) => {
            const quarter = goal.quarter;
            if (!acc[quarter]) {
                acc[quarter] = {
                    goals: [],
                    reviewer_comment: goal.reviewer_comment,
                    final_rating: goal.final_rating,
                    reviewer_rating: goal.reviewer_rating 
                };
            }
            acc[quarter].goals.push(goal);
            return acc;
        }, {});

        if (Object.keys(quarterGroups).length === 0) {
            return (
                <div className="pms-empty-state">
                    <p>No submitted goals found.</p>
                </div>
            );
        }

        return (
            <div className="quarter-cards-container">
                {Object.keys(quarterGroups).map((quarter) => {
                    const { goals, reviewer_comment, final_rating, reviewer_rating } = quarterGroups[quarter];

                    return (
                        <div key={quarter} className="quarter-card">
                            <h2 className="quarter-card-title">{quarter}</h2>
                            
                            <div className="history-table-wrapper">
                                <table className="history-table">
                                    <thead>
                                        <tr>
                                            <th>Goal Description</th>
                                            <th>Self Assessment</th>
                                            <th>Attachments</th>
                                            <th>Communicated</th>
                                            <th>Self Rating</th>
                                            <th>Reviewer Rating</th>
                                            <th>Date Submitted</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {goals.map((goal) => (
                                            <tr key={goal._id}>
                                                <td>{goal.goal_description}</td>
                                                <td>{goal.self_assessment}</td>
                                                <td>
                                                    {goal.attachments ? (
                                                        <a href={goal.attachments} target="_blank" rel="noopener noreferrer">
                                                            View Attachment
                                                        </a>
                                                    ) : 'No Attachment'}
                                                </td>
                                                <td>
                                                    <span className={`pms-badge ${goal.communicated ? 'pms-badge-success' : 'pms-badge-warning'}`}>
                                                        {goal.communicated ? 'Yes' : 'No'}
                                                    </span>
                                                </td>
                                                <td>{goal.self_rating}</td>
                                                <td>{goal.reviewer_rating}</td>
                                                <td>{new Date(goal.submitted_at).toLocaleString()}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="quarter-review-section">
                                <div className="quarter-review-details">
                                    <div className="final-rating-container">
                                        <span className="final-rating-label">Final Rating:</span>
                                        <span className="final-rating-value">{final_rating || 'N/A'}</span>
                                    </div>
                                    <div className="reviewer-comment-box">
                                        <strong>Reviewer Comment: </strong>{reviewer_comment || 'No comment provided.'}
                                    </div>
                                </div>

                                <div className="quarter-buttons">
                                    <AcknowledgmentButton
                                        employeeId={employeeInfo.employee_number}
                                        goalId={goals[0].id}
                                        reviewerComment={reviewer_comment}
                                        finalRating={final_rating}
                                        acknowledged={acknowledgedStatus[quarter] === 1}
                                        quarter={quarter}
                                        onAcknowledged={(goalId) => updateAcknowledgedState(goalId)}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div className="history-container pms-page">
            <AppHeader 
                title="SUBMITTED GOALS" 
                employeeInfo={employeeInfo} 
            />

            <main className="history-body pms-main">
                {isLoading ? (
                    <p>Loading...</p>
                ) : (
                    renderQuarterCards()
                )}
            </main>
        </div>
    );
};

export default History;
